import * as React from "react";
import styled, { theme } from "../styled";
import { Stack } from "./Stack";
import { Logo } from "../design-system/components/Logo";

const Wrapper = styled("div")`
  width: 100%;
  margin-top: ${theme.spacing.m};
`;

export const Header: React.FC = () => {
  return (
    <Wrapper>
      <Stack distribution="center" alignment="center">
        <Logo width={174} height={48} />
      </Stack>
    </Wrapper>
  );
};
